import React from 'react';
import PropTypes from 'prop-types';

const LocalBusiness = (props) => (
	<script
		type='application/ld+json'
		dangerouslySetInnerHTML={{
			__html: `{
                "@context": "https://schema.org",
                "@type": "HomeAndConstructionBusiness",
                "name": "${props.name}",
                "url": "${process.env.GATSBY_SITE_URL + props.url}",
                "logo": ["https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/blt5d51af0d3a33260d/63615b77ff7b405f6b3f58e9/pella-logo-black-spot.png"],
                "image": ["https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/blt5d51af0d3a33260d/63615b77ff7b405f6b3f58e9/pella-logo-black-spot.png"]
            }`,
		}}
	/>
);

LocalBusiness.propTypes = {
	name: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
};

export default LocalBusiness;
